import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const tableV4Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Table element to v4 by migrating default pageSize',
  run: (props: PartialPropsOf<'table'>): void => {
    if (!props?.content?.pagination?.count) {
      props.content = {
        ...props.content,
        pagination: {
          ...props.content?.pagination,
          count: 5,
        },
      };
    }
  },
};
